// extracted by mini-css-extract-plugin
export default {"type":"styles_type__P6VhB","wl":"styles_wl__EQltl","ce":"styles_ce__vHstw","vb":"styles_vb__vCZ8i"};